import React from 'react';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload,faShareNodes } from '@fortawesome/free-solid-svg-icons';
import { downloadCertificate, generateCertificate } from '../../../../utils/generateCertificate';
import {editRedirectType ,editLastVisitedMicroskill,editLastVisitedCertificate} from '../../../../redux/actions/userActivity'
import { LINKEDIN_REDIRECT_URI } from '../../../../config/api_config';

const TaskCertificate = ({ image_link , user_task }) => {
 
  const dispatch = useDispatch();

  function linkedinTaskAuth(e) {
    try {
      dispatch(editRedirectType('task_certificate_share'));
      dispatch(editLastVisitedCertificate(e));

      const client_id = '78d1eot06iq0ru';
      // console.log(client_id)
      const url = `https://www.linkedin.com/oauth/v2/authorization?client_id=${client_id}&redirect_uri=${LINKEDIN_REDIRECT_URI}&response_type=code&scope=w_member_social r_liteprofile r_emailaddress`;
      window.location.href = url;
      return { success: true };
    } catch (err) {
      console.log(err);
      return { success: false };
    }
  }
  return (
    image_link && (
      <div className="flex flex-col items-center justify-center ">
        <img src={image_link} alt="certificate image" className=" lg:h-2/3 lg:w-2/3"></img>
        <div className='flex justify-center items-center'>
          <button
            className="mt-2 mb-2 cursor-pointer rounded-lg bg-[#10A786] px-2 py-2 text-xs text-white lg:mt-4 lg:mb-4 lg:text-lg"
            onClick={(e) => {
             downloadCertificate(image_link);
            }}
          >
            Download <FontAwesomeIcon icon={faDownload} />
            </button>
            <button className={`bg-[#10A786] flex  items-center justify-center rounded-md  ml-7 px-3  py-2 lg:px-3 lg:py-3 font-medium text-white`}
              onClick={(e) => {
                linkedinTaskAuth(user_task);
              } }>

              <FontAwesomeIcon
              icon={faShareNodes}
              // size="1x"
                />
              </button>
        </div>
      </div>
    )
  );
};

export default TaskCertificate;
